/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".download[_ngcontent-%COMP%]{margin-left:63px;margin-top:10px;font-size:small}.download[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{padding-right:10px}"];
export { styles as styles };
